import {Utilities} from '@shared/utilities/utilities.model';

export interface DigitalSignerModel {
	certificate_alias: string;
	client_signer_id: string;
	infocert_signer_id: string;
	role: string;
	identity_assertion_policy: string;
	legal_id_country_code: string;
	legal_id_serial_type: string;
	legal_id_serial_number: string;
	fiscal_code: string;
	first_name: string;
	last_name: string;
	birth_date: string;
	sex: string;
	citizenship: string;
	birth_place: string;
	birth_province: string;
	birth_country: string;
	email: string;
	mobile_number: string;
	address_street: string;
	address_number: string;
	address_zip: string;
	address_city: string;
	address_province: string;
	address_country: string;
	identity_document_issue_country: string;
	identity_document_type: string;
	identity_document_number: string;
	identity_document_issuer: string;
	identity_document_issue_place: string;
	identity_document_issue_province: string;
	identity_document_issue_date: string;
	identity_document_expiration_date: string;
	process_token: string;
	process_session_key: string;
	certificate_domain: string;
	default_redirect_url: string;
	failure_redirect_url: string;
}

export class DigitalSignProcessDocument {
	id: string;
	name: string;
	status: string;
	url: string;
	type: string;
	signatures: DigitalSignProcessDocumentSignatures[];
	simpleClauses: DigitalSignSimpleClauseModel[];
	isAllChecked: boolean = false;

	constructor(model?: any) {
		if (!!model) {
			this.id = model.id;
			this.name = model.name;
			this.status = model.status;
			this.url = model.url;
			this.type = model.type;
			this.signatures = [];
			this.simpleClauses = [];
			if (!!model.signatures) {
				model.signatures.forEach(signature => {
					const signatures: DigitalSignProcessDocumentSignatures = new DigitalSignProcessDocumentSignatures(signature);
					this.signatures.push(signatures);
					this.simpleClauses.push(new DigitalSignSimpleClauseModel(signatures.id, signatures.text, this.url, 1));
				});
			}
		}
	}

	setIsAllChecked(): void {
		if (!Utilities.isVoid(this.simpleClauses)) {
			for (let i: number = 0; i < this.simpleClauses.length; i++) {
				if (this.simpleClauses[i].values.includes(false)) {
					if (this.simpleClauses[i].id !== DigitalSignSimpleClauseModel.MODE_FIXED) {
						this.isAllChecked = false;
						return;
					}
					this.simpleClauses[i].values.fill(true);
				}
			}
		}
		this.isAllChecked = true;
	}
}

export class DigitalSignOperatorStartedProcess {
	status: string;
	documents: DigitalSignProcessDocument[];

	constructor(model?: any) {
		if (!!model) {
			this.status = model.status;
			this.documents = [];
			if (!!model.documents) {
				model.documents.forEach( document => this.documents.push(new DigitalSignProcessDocument(document)));
			}
		}
	}
}


export class DigitalSignProcessDocumentSignatures {
	id: string;
	text: string;

	constructor(model?: any) {
		if (!!model) {
			this.id = model.id;
			this.text = model.text;
		}
	}
}

export class DigitalSignSimpleClauseModel {
	static MODE_FIXED: string = 'FIXED';
	id: string;
	values: boolean[];
	text: string;
	mode: string;

	constructor(id: string, text: string, mode: string, length: number) {
		this.id = id;
		this.values = Array(length).fill(false);
		this.text = text;
		this.mode = mode;
	}
}

export class DigitalSignStartedCustomerClauseUrlProcess {
	name: string;
	url: string;

	constructor(model?: any) {
		if (!!model) {
			this.name = model.name;
			this.url = model.url;
		}
	}
}


export class DigitalSignStartedCustomerClauseProcess {
	group: string;
	id: string;
	text: string;
	urls: DigitalSignStartedCustomerClauseUrlProcess [];
	mode: string;
	optional: boolean;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.group = model.group;
			this.id = model.id;
			this.text = model.text;
			this.mode = model.mode;
			this.optional = model.optional;
			this.urls = [];
			if (!!model.urls) {
				model.urls.forEach( url => this.urls.push(new DigitalSignStartedCustomerClauseUrlProcess(url)));
			}
		}
	}
}


export class DigitalSignStartedCustomerProcess {

	status: string;
	person: any;

	clauses: DigitalSignStartedCustomerClauseProcess[];
	simpleClauses: DigitalSignSimpleClauseModel[];

	constructor(model?: any) {
		if (!!model) {
			this.status = model.text;
			this.clauses = [];
			this.simpleClauses = [];
			if (!!model.clauses) {
				for (let i: number = 0; i < model.clauses.length; i++) {
					const clauseProcess: DigitalSignStartedCustomerClauseProcess = new DigitalSignStartedCustomerClauseProcess(model.clauses[i]);
					this.clauses.push(clauseProcess);
					const valuesLength: number = (clauseProcess.urls.length > 0 ? clauseProcess.urls.length : 1);
					this.simpleClauses.push(new DigitalSignSimpleClauseModel(clauseProcess.id, clauseProcess.text, clauseProcess.mode, valuesLength));
				}
			}
			this.person = model.person;
		}
	}
}

